module.exports = __webpack_public_path__ + "static/img/9e.b55886b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9e.jpg
// module id = SlE0
// module chunks = 0